import { PublicKey, sendAndConfirmTransaction, Keypair, clusterApiUrl, TransactionInstruction, SYSVAR_RENT_PUBKEY, SystemProgram, Transaction, Connection } from '@solana/web3.js';
import { serialize, BorshError, BinaryReader } from 'borsh';
import { encode, decode } from 'bs58';
import { omit, mergeWith, has, complement, isNil, filter, pick, without, flatten } from 'ramda';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var DID_HEADER = 'did';
var DID_METHOD = 'sol';
var PROGRAM_ID = /*#__PURE__*/new PublicKey('idDa4XeCjVwKcprVAo812coUQbovSZ4kDGJf2sPaBnM');
var SOLANA_COMMITMENT = 'confirmed';
var DEFAULT_DOCUMENT_SIZE = 1000;
var W3ID_CONTEXT = 'https://w3id.org/did/v1.0';
var SOL_CONTEXT_PREFIX = 'https://w3id.org/sol/v';

var SolanaUtil = /*#__PURE__*/function () {
  function SolanaUtil() {}

  SolanaUtil.sendAndConfirmTransaction = function sendAndConfirmTransaction$1(connection, transaction) {
    for (var _len = arguments.length, signers = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      signers[_key - 2] = arguments[_key];
    }

    return sendAndConfirmTransaction(connection, transaction, signers, {
      skipPreflight: false,
      commitment: SOLANA_COMMITMENT,
      preflightCommitment: 'recent'
    });
  };

  SolanaUtil.newAccountWithLamports = /*#__PURE__*/function () {
    var _newAccountWithLamports = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(connection, lamports) {
      var account, retries, balance;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (lamports === void 0) {
                lamports = 1000000;
              }

              account = Keypair.generate();
              retries = 30;
              _context.next = 5;
              return connection.requestAirdrop(account.publicKey, lamports);

            case 5:
              _context.next = 7;
              return this.sleep(500);

            case 7:
              _context.next = 9;
              return connection.getBalance(account.publicKey);

            case 9:
              balance = _context.sent;

              if (!(lamports <= balance)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", account);

            case 12:
              if (!(--retries <= 0)) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("break", 16);

            case 14:
              _context.next = 5;
              break;

            case 16:
              throw new Error("Airdrop of " + lamports + " failed");

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function newAccountWithLamports(_x, _x2) {
      return _newAccountWithLamports.apply(this, arguments);
    }

    return newAccountWithLamports;
  }();

  SolanaUtil.sleep = function sleep(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };

  return SolanaUtil;
}();

var Assignable = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function Assignable(properties) {
    var _this = this;

    Object.keys(properties).forEach(function (key) {
      _this[key] = properties[key];
    });
  }

  var _proto = Assignable.prototype;

  _proto.encode = function encode() {
    return Buffer.from(serialize(SCHEMA, this));
  };

  Assignable.decode = function decode(data) {
    return deserializeExtraBytes(SCHEMA, this, data);
  };

  return Assignable;
}(); // Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS

var Enum = /*#__PURE__*/function (_Assignable) {
  _inheritsLoose(Enum, _Assignable);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function Enum(properties) {
    var _this2;

    _this2 = _Assignable.call(this, properties) || this;

    if (Object.keys(properties).length !== 1) {
      throw new Error('Enum can only take single value');
    }

    _this2["enum"] = '';
    Object.keys(properties).forEach(function (key) {
      _this2["enum"] = key;
    });
    return _this2;
  }

  return Enum;
}(Assignable);
var SCHEMA = /*#__PURE__*/new Map(); // TODO PR for leaving extra bytes, a lot of code copied from
// https://github.com/near/borsh-js/blob/master/borsh-ts/index.ts

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function deserializeField(schema, fieldName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
fieldType, reader // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  try {
    if (typeof fieldType === 'string') {
      return reader["read" + capitalizeFirstLetter(fieldType)]();
    }

    if (fieldType instanceof Array) {
      if (typeof fieldType[0] === 'number') {
        return reader.readFixedArray(fieldType[0]);
      }

      return reader.readArray(function () {
        return deserializeField(schema, fieldName, fieldType[0], reader);
      });
    }

    return deserializeStruct(schema, fieldType, reader);
  } catch (error) {
    if (error instanceof BorshError) {
      error.addToFieldPath(fieldName);
    }

    throw error;
  }
}

function deserializeStruct(schema, // eslint-disable-next-line @typescript-eslint/no-explicit-any
classType, reader) {
  var structSchema = schema.get(classType);

  if (!structSchema) {
    throw new BorshError("Class " + classType.name + " is missing in schema");
  }

  if (structSchema.kind === 'struct') {
    var result = {};

    for (var _iterator = _createForOfIteratorHelperLoose(schema.get(classType).fields), _step; !(_step = _iterator()).done;) {
      var _step$value = _step.value,
          fieldName = _step$value[0],
          fieldType = _step$value[1];
      result[fieldName] = deserializeField(schema, fieldName, fieldType, reader);
    }

    return new classType(result);
  }

  if (structSchema.kind === 'enum') {
    var _classType;

    var idx = reader.readU8();

    if (idx >= structSchema.values.length) {
      throw new BorshError("Enum index: " + idx + " is out of range");
    }

    var _structSchema$values$ = structSchema.values[idx],
        _fieldName = _structSchema$values$[0],
        _fieldType = _structSchema$values$[1];
    var fieldValue = deserializeField(schema, _fieldName, _fieldType, reader);
    return new classType((_classType = {}, _classType[_fieldName] = fieldValue, _classType));
  }

  throw new BorshError("Unexpected schema kind: " + structSchema.kind + " for " + classType.constructor.name);
} /// Deserializes object from bytes using schema.


function deserializeExtraBytes(schema, // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
classType, buffer) {
  var reader = new BinaryReader(buffer);
  return deserializeStruct(schema, classType, reader);
}

function getPDAKeyFromAuthority(_x) {
  return _getPDAKeyFromAuthority.apply(this, arguments);
} // The current SOL method version

function _getPDAKeyFromAuthority() {
  _getPDAKeyFromAuthority = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(authority) {
    var publicKeyNonce;
    return runtime_1.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return PublicKey.findProgramAddress([authority.toBuffer(), Buffer.from(DID_METHOD, 'utf8')], PROGRAM_ID);

          case 2:
            publicKeyNonce = _context5.sent;
            return _context5.abrupt("return", publicKeyNonce[0]);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getPDAKeyFromAuthority.apply(this, arguments);
}

var VERSION = '1'; // The identifier for a default verification method, i.e one inferred from the authority

var DEFAULT_KEY_ID = 'default';
var SolData = /*#__PURE__*/function (_Assignable) {
  _inheritsLoose(SolData, _Assignable);

  function SolData(constructor) {
    return _Assignable.call(this, {
      accountVersion: 1,
      account: constructor.account || SolPublicKey.empty(),
      authority: constructor.authority || SolPublicKey.empty(),
      cluster: constructor.cluster || ClusterType.mainnetBeta(),
      version: constructor.version || VERSION,
      controller: constructor.controller || [],
      verificationMethod: constructor.verificationMethod || [],
      authentication: constructor.authentication || [],
      capabilityInvocation: constructor.capabilityInvocation || [],
      capabilityDelegation: constructor.capabilityDelegation || [],
      keyAgreement: constructor.keyAgreement || [],
      assertionMethod: constructor.assertionMethod || [],
      service: constructor.service || []
    }) || this;
  }

  SolData.fromAccount = function fromAccount(accountKey, accountData, cluster) {
    var solData = SolData.decode(accountData);

    if (solData.accountVersion !== 1) {
      throw new Error('Invliad account version: ' + solData.accountVersion);
    }

    solData.cluster = cluster;
    solData.account = SolPublicKey.fromPublicKey(accountKey);
    return solData;
  };

  var _proto = SolData.prototype;

  _proto.forAuthority = function forAuthority(authority) {
    return new SolData(_extends({}, this, {
      authority: SolPublicKey.fromPublicKey(authority)
    }));
  };

  _proto.merge = function merge(other, overwriteArrays) {
    if (overwriteArrays === void 0) {
      overwriteArrays = false;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var mergeBehaviour = function mergeBehaviour(a, b) {
      if (a && Array.isArray(a)) {
        return overwriteArrays && b ? b : [].concat(a, b);
      }

      return b;
    }; // merging data into a DID Document should not change its identifier (derived from the authority)


    var dataToMerge = omit(['authority', 'account'], other);
    var mergedData = mergeWith(mergeBehaviour, this, dataToMerge);
    return new SolData(mergedData);
  };

  SolData.size = function size() {
    return 1000;
  };

  SolData.solContext = function solContext(version) {
    if (version === void 0) {
      version = VERSION;
    }

    return SOL_CONTEXT_PREFIX + version;
  };

  SolData.defaultContext = function defaultContext(version) {
    if (version === void 0) {
      version = VERSION;
    }

    return [W3ID_CONTEXT, SolData.solContext(version)];
  };

  SolData.sparse = function sparse(account, authority, clusterType) {
    return new SolData({
      cluster: clusterType,
      authority: SolPublicKey.fromPublicKey(authority),
      account: SolPublicKey.fromPublicKey(account),
      version: VERSION,
      controller: [],
      verificationMethod: [],
      authentication: [],
      capabilityInvocation: [],
      capabilityDelegation: [],
      keyAgreement: [],
      assertionMethod: [],
      service: []
    });
  };

  SolData.empty = /*#__PURE__*/function () {
    var _empty = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(authority) {
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = authority ? SolPublicKey.fromPublicKey(authority) : undefined;

              if (!authority) {
                _context.next = 9;
                break;
              }

              _context.t2 = SolPublicKey;
              _context.next = 5;
              return getPDAKeyFromAuthority(authority);

            case 5:
              _context.t3 = _context.sent;
              _context.t1 = _context.t2.fromPublicKey.call(_context.t2, _context.t3);
              _context.next = 10;
              break;

            case 9:
              _context.t1 = undefined;

            case 10:
              _context.t4 = _context.t1;
              return _context.abrupt("return", {
                authority: _context.t0,
                account: _context.t4
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function empty(_x2) {
      return _empty.apply(this, arguments);
    }

    return empty;
  }();

  _proto.identifier = function identifier() {
    return new DecentralizedIdentifier({
      clusterType: this.cluster,
      authorityPubkey: this.authority
    });
  }
  /**
   * Infers a set of verification methods by combining:
   * 1. The authority
   * 2. the explicit verification methods stored in the document
   *
   * Should match the program function state.rs SolData.inferred_verification_methods
   */
  ;

  _proto.inferredVerificationMethods = function inferredVerificationMethods() {
    return [VerificationMethod.newPublicKey(this.authority.toPublicKey())].concat(this.verificationMethod);
  }
  /*
   * Infers a set of capability invocations from either:
   * 1. The authority
   * 2. the explicit capability invocations stored in the document
   * By default, the authority is also the key that is allowed to update or delete the DID,
   * However, if an explicit capability invocation list is specified, this can be overruled,
   * allowing revocability of lost keys while retaining the original DID identifier (which is
   * derived from the authority)
   *
   * Should match the program function state.rs SolData.inferred_capability_invocation
   */
  ;

  _proto.inferredCapabilityInvocation = function inferredCapabilityInvocation() {
    return this.capabilityInvocation && this.capabilityInvocation.length ? this.capabilityInvocation : [DEFAULT_KEY_ID];
  };

  _proto.toDIDDocument = function toDIDDocument() {
    var _this = this;

    var deriveDID = function deriveDID(urlField) {
      return _this.identifier().withUrl(urlField).toString();
    };

    var verificationMethods = this.inferredVerificationMethods().map(function (v) {
      return v.toDID(_this.identifier());
    });
    return {
      '@context': SolData.defaultContext(this.version),
      id: this.identifier().toString(),
      controller: this.controller.map(function (controller) {
        return DecentralizedIdentifier.create(controller.toPublicKey(), _this.cluster).toString();
      }),
      verificationMethod: verificationMethods,
      authentication: this.authentication.map(deriveDID),
      assertionMethod: this.assertionMethod.map(deriveDID),
      keyAgreement: this.keyAgreement.map(deriveDID),
      capabilityInvocation: this.inferredCapabilityInvocation().map(deriveDID),
      capabilityDelegation: this.capabilityDelegation.map(deriveDID),
      service: this.service.map(function (v) {
        return v.toDID(_this.identifier());
      }),
      publicKey: verificationMethods
    };
  } // extract the version from a DID JSON-LD context, if the context is an array
  // and includes the Sol Context Prefix.
  // Otherwise, just return the default version.
  ;

  SolData.parseVersion = function parseVersion(context) {
    if (context && Array.isArray(context)) {
      var solContext = context.find(function (c) {
        return c.startsWith(SOL_CONTEXT_PREFIX);
      });
      if (solContext) return solContext.substring(SOL_CONTEXT_PREFIX.length);
    }

    return VERSION;
  };

  SolData.parseDIDReferenceArray = function parseDIDReferenceArray(dids) {
    return DecentralizedIdentifier.parseMaybeArray(dids).map(function (did) {
      return did.urlField;
    }).filter(function (val) {
      return val !== undefined;
    });
  };

  SolData.parse = /*#__PURE__*/function () {
    var _parse = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(document) {
      var did;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              did = document.id ? DecentralizedIdentifier.parse(document.id) : DecentralizedIdentifier.empty();
              _context2.t0 = SolData;
              _context2.next = 4;
              return did.pdaPubkey();

            case 4:
              _context2.t1 = _context2.sent;
              _context2.t2 = did.authorityPubkey;
              _context2.t3 = did.clusterType;
              _context2.t4 = SolData.parseVersion(document['@context']);
              _context2.t5 = normalizeController(document.controller);
              _context2.t6 = document.verificationMethod ? document.verificationMethod.map(function (v) {
                return VerificationMethod.parse(v);
              }) : [];
              _context2.t7 = SolData.parseDIDReferenceArray(document.authentication);
              _context2.t8 = SolData.parseDIDReferenceArray(document.capabilityInvocation);
              _context2.t9 = SolData.parseDIDReferenceArray(document.capabilityDelegation);
              _context2.t10 = SolData.parseDIDReferenceArray(document.keyAgreement);
              _context2.t11 = SolData.parseDIDReferenceArray(document.assertionMethod);
              _context2.t12 = document.service ? document.service.map(function (v) {
                return ServiceEndpoint.parse(v);
              }) : [];
              _context2.t13 = {
                account: _context2.t1,
                authority: _context2.t2,
                cluster: _context2.t3,
                version: _context2.t4,
                controller: _context2.t5,
                verificationMethod: _context2.t6,
                authentication: _context2.t7,
                capabilityInvocation: _context2.t8,
                capabilityDelegation: _context2.t9,
                keyAgreement: _context2.t10,
                assertionMethod: _context2.t11,
                service: _context2.t12
              };
              return _context2.abrupt("return", new _context2.t0(_context2.t13));

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function parse(_x3) {
      return _parse.apply(this, arguments);
    }

    return parse;
  }();

  return SolData;
}(Assignable);

var normalizeController = function normalizeController(controller) {
  if (controller) {
    if (Array.isArray(controller)) {
      return controller.map(DecentralizedIdentifier.parse).map(function (id) {
        return id.authorityPubkey;
      });
    } else {
      return [DecentralizedIdentifier.parse(controller).authorityPubkey];
    }
  } else {
    return [];
  }
};

var VerificationMethod = /*#__PURE__*/function (_Assignable2) {
  _inheritsLoose(VerificationMethod, _Assignable2);

  function VerificationMethod() {
    return _Assignable2.apply(this, arguments) || this;
  }

  VerificationMethod.defaultVerificationType = function defaultVerificationType() {
    return 'Ed25519VerificationKey2018';
  };

  VerificationMethod.newPublicKey = function newPublicKey(authority, id) {
    if (id === void 0) {
      id = DEFAULT_KEY_ID;
    }

    var verificationType = VerificationMethod.defaultVerificationType();
    var pubkey = SolPublicKey.fromPublicKey(authority);
    return new VerificationMethod({
      id: id,
      verificationType: verificationType,
      pubkey: pubkey
    });
  };

  var _proto2 = VerificationMethod.prototype;

  _proto2.toDID = function toDID(parentDID) {
    return {
      id: parentDID.withUrl(this.id).toString(),
      type: this.verificationType,
      controller: parentDID.toString(),
      publicKeyBase58: this.pubkey.toString()
    };
  };

  VerificationMethod.parse = function parse(didVerificationMethod) {
    return new VerificationMethod({
      id: DecentralizedIdentifier.parse(didVerificationMethod.id).urlField,
      verificationType: didVerificationMethod.type,
      controller: DecentralizedIdentifier.parse(didVerificationMethod.controller),
      pubkey: didVerificationMethod.publicKeyBase58 ? SolPublicKey.parse(didVerificationMethod.publicKeyBase58) : undefined
    });
  };

  return VerificationMethod;
}(Assignable);
var ServiceEndpoint = /*#__PURE__*/function (_Assignable3) {
  _inheritsLoose(ServiceEndpoint, _Assignable3);

  function ServiceEndpoint() {
    return _Assignable3.apply(this, arguments) || this;
  }

  var _proto3 = ServiceEndpoint.prototype;

  _proto3.toDID = function toDID(parentDID) {
    return {
      id: parentDID.withUrl(this.id).toString(),
      type: this.endpointType,
      serviceEndpoint: this.endpoint,
      description: this.description
    };
  };

  ServiceEndpoint.parse = function parse(service) {
    return new ServiceEndpoint({
      id: DecentralizedIdentifier.parse(service.id).urlField,
      endpointType: service.type,
      endpoint: service.serviceEndpoint,
      description: service.description
    });
  };

  return ServiceEndpoint;
}(Assignable);
/**
 * A class representing a SOL Did
 */

var DecentralizedIdentifier = /*#__PURE__*/function (_Assignable4) {
  _inheritsLoose(DecentralizedIdentifier, _Assignable4);

  /**
   * Creates a new `DecentralizedIdentifier` from its requisite parts.
   *
   * Use `DecentralizedIdentifier::parse` to obtain this from a direct did address.
   *
   * @param constructor The construction values
   */
  function DecentralizedIdentifier(constructor) {
    return _Assignable4.call(this, {
      clusterType: constructor.clusterType,
      authorityPubkey: constructor.authorityPubkey,
      urlField: constructor.urlField
    }) || this;
  }
  /**
   * Get the key to the DID data
   */


  var _proto4 = DecentralizedIdentifier.prototype;

  _proto4.pdaPubkey =
  /*#__PURE__*/
  function () {
    var _pdaPubkey = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = SolPublicKey;
              _context3.next = 3;
              return getPDAKeyFromAuthority(this.authorityPubkey.toPublicKey());

            case 3:
              _context3.t1 = _context3.sent;
              return _context3.abrupt("return", _context3.t0.fromPublicKey.call(_context3.t0, _context3.t1));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function pdaPubkey() {
      return _pdaPubkey.apply(this, arguments);
    }

    return pdaPubkey;
  }();

  _proto4.pdaSolanaPubkey = /*#__PURE__*/function () {
    var _pdaSolanaPubkey = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4() {
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.pdaPubkey().then(function (key) {
                return key.toPublicKey();
              }));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function pdaSolanaPubkey() {
      return _pdaSolanaPubkey.apply(this, arguments);
    }

    return pdaSolanaPubkey;
  }()
  /**
   * Clones this
   */
  ;

  _proto4.clone = function clone() {
    return new DecentralizedIdentifier({
      clusterType: this.clusterType,
      authorityPubkey: this.authorityPubkey,
      urlField: this.urlField
    });
  }
  /**
   * Returns a new `DecentralizedIdentifier` but with `urlField` swapped to the parameter
   * @param urlField The new url field
   */
  ;

  _proto4.withUrl = function withUrl(urlField) {
    return new DecentralizedIdentifier(_extends({}, this, {
      urlField: urlField
    }));
  };

  _proto4.toString = function toString() {
    var cluster = this.clusterType.mainnetBeta ? '' : this.clusterType.toString() + ":";
    var urlField = !this.urlField || this.urlField === '' ? '' : "#" + this.urlField; // TODO add support for / urls

    return DID_HEADER + ":" + DID_METHOD + ":" + cluster + this.authorityPubkey.toString() + urlField;
  }
  /**
   * Parses a given did string
   * @param did the did string
   */
  ;

  DecentralizedIdentifier.parse = function parse(did) {
    if (typeof did == 'string') {
      var matches = DecentralizedIdentifier.REGEX.exec(did);
      if (!matches) throw new Error('Invalid DID');
      var authorityPubkey = SolPublicKey.parse(matches[2]);
      return new DecentralizedIdentifier({
        clusterType: ClusterType.parse(matches[1]),
        authorityPubkey: authorityPubkey,
        urlField: matches[3]
      });
    } else {
      throw new Error('Provided DID is not a string');
    }
  }
  /**
   * Returns true if the did is valid
   * @param did The did string to check
   */
  ;

  DecentralizedIdentifier.valid = function valid(did) {
    try {
      DecentralizedIdentifier.parse(did);
      return true;
    } catch (_unused) {
      return false;
    }
  }
  /**
   * Returns an empty did
   */
  ;

  DecentralizedIdentifier.empty = function empty() {
    return new DecentralizedIdentifier({
      clusterType: ClusterType.mainnetBeta(),
      authorityPubkey: SolPublicKey.empty(),
      urlField: ''
    });
  }
  /**
   * Parses an array of did strings
   * @param dids The did strings to parse
   */
  ;

  DecentralizedIdentifier.parseMaybeArray = function parseMaybeArray(dids) {
    return dids ? dids.map(function (v) {
      return DecentralizedIdentifier.parse(v);
    }) : [];
  }
  /**
   * Creates a new did
   * @param authorityPubkey The authority and key of the did
   * @param clusterType The cluster the did points to
   * @param urlField An optional extra field
   */
  ;

  DecentralizedIdentifier.create = function create(authorityPubkey, clusterType, urlField) {
    return new DecentralizedIdentifier({
      authorityPubkey: SolPublicKey.fromPublicKey(authorityPubkey),
      clusterType: clusterType,
      urlField: urlField
    });
  };

  return DecentralizedIdentifier;
}(Assignable);
DecentralizedIdentifier.REGEX = /*#__PURE__*/new RegExp('^did:' + DID_METHOD + ':?(\\w*):(\\w+)#?(\\w*)$');
var SolPublicKey = /*#__PURE__*/function (_Assignable5) {
  _inheritsLoose(SolPublicKey, _Assignable5);

  function SolPublicKey() {
    return _Assignable5.apply(this, arguments) || this;
  }

  var _proto5 = SolPublicKey.prototype;

  _proto5.toPublicKey = function toPublicKey() {
    return new PublicKey(this.bytes);
  };

  _proto5.toString = function toString() {
    return encode(this.bytes);
  };

  SolPublicKey.parse = function parse(pubkey) {
    return SolPublicKey.fromPublicKey(new PublicKey(pubkey));
  };

  SolPublicKey.fromPublicKey = function fromPublicKey(publicKey) {
    return new SolPublicKey({
      bytes: Uint8Array.from(publicKey.toBuffer())
    });
  };

  SolPublicKey.empty = function empty() {
    var bytes = new Array(32);
    bytes.fill(0);
    return new SolPublicKey({
      bytes: bytes
    });
  };

  return SolPublicKey;
}(Assignable);
var ClusterType = /*#__PURE__*/function (_Enum) {
  _inheritsLoose(ClusterType, _Enum);

  function ClusterType() {
    return _Enum.apply(this, arguments) || this;
  }

  var _proto6 = ClusterType.prototype;

  _proto6.solanaUrl = function solanaUrl() {
    if (this.development !== undefined) return 'http://localhost:8899';
    if (this.civicnet !== undefined) return 'https://d3ab7dlfud2b5u.cloudfront.net';
    return clusterApiUrl(this.toCluster());
  };

  _proto6.toString = function toString() {
    return this.development ? 'localnet' : this.toCluster();
  }
  /**
   * Returns this as the portion of the DID string
   */
  ;

  _proto6.toDIDString = function toDIDString() {
    if (this.testnet) {
      return ':testnet';
    } else if (this.mainnetBeta) {
      return '';
    } else if (this.devnet) {
      return ':devnet';
    } else if (this.development) {
      return ':localnet';
    }

    throw new Error('Unknown `ClusterType`: ' + this);
  };

  _proto6.toCluster = function toCluster() {
    if (this.mainnetBeta) {
      return 'mainnet-beta';
    } else if (this.testnet) {
      return 'testnet';
    } else if (this.devnet) {
      return 'devnet';
    } else if (this.civicnet) {
      return 'civicnet';
    } else {
      throw new Error('Unknown cluster type');
    }
  };

  ClusterType.testnet = function testnet() {
    return new ClusterType({
      testnet: new Testnet({})
    });
  };

  ClusterType.mainnetBeta = function mainnetBeta() {
    return new ClusterType({
      mainnetBeta: new MainnetBeta({})
    });
  };

  ClusterType.devnet = function devnet() {
    return new ClusterType({
      devnet: new Devnet({})
    });
  };

  ClusterType.civicnet = function civicnet() {
    return new ClusterType({
      civicnet: new Civicnet({})
    });
  };

  ClusterType.development = function development() {
    return new ClusterType({
      development: new Development({})
    });
  };

  ClusterType.parse = function parse(clusterString) {
    switch (clusterString) {
      case 'testnet':
        return ClusterType.testnet();

      case 'devnet':
        return ClusterType.devnet();

      case 'localnet':
        return ClusterType.development();

      case 'mainnet-beta':
        return ClusterType.mainnetBeta();

      case 'civicnet':
        return ClusterType.civicnet();

      case '':
        return ClusterType.mainnetBeta();

      default:
        throw new Error("Cluster string '" + clusterString + "' not recognized");
    }
  };

  return ClusterType;
}(Enum);
var Testnet = /*#__PURE__*/function (_Assignable6) {
  _inheritsLoose(Testnet, _Assignable6);

  function Testnet() {
    return _Assignable6.apply(this, arguments) || this;
  }

  return Testnet;
}(Assignable);
var MainnetBeta = /*#__PURE__*/function (_Assignable7) {
  _inheritsLoose(MainnetBeta, _Assignable7);

  function MainnetBeta() {
    return _Assignable7.apply(this, arguments) || this;
  }

  return MainnetBeta;
}(Assignable);
var Devnet = /*#__PURE__*/function (_Assignable8) {
  _inheritsLoose(Devnet, _Assignable8);

  function Devnet() {
    return _Assignable8.apply(this, arguments) || this;
  }

  return Devnet;
}(Assignable);
var Civicnet = /*#__PURE__*/function (_Assignable9) {
  _inheritsLoose(Civicnet, _Assignable9);

  function Civicnet() {
    return _Assignable9.apply(this, arguments) || this;
  }

  return Civicnet;
}(Assignable);
var Development = /*#__PURE__*/function (_Assignable10) {
  _inheritsLoose(Development, _Assignable10);

  function Development() {
    return _Assignable10.apply(this, arguments) || this;
  }

  return Development;
}(Assignable);
SCHEMA.set(SolData, {
  kind: 'struct',
  fields: [['accountVersion', 'u8'], ['authority', SolPublicKey], ['version', 'string'], ['controller', [SolPublicKey]], ['verificationMethod', [VerificationMethod]], ['authentication', ['string']], ['capabilityInvocation', ['string']], ['capabilityDelegation', ['string']], ['keyAgreement', ['string']], ['assertionMethod', ['string']], ['service', [ServiceEndpoint]]]
});
SCHEMA.set(VerificationMethod, {
  kind: 'struct',
  fields: [['id', 'string'], ['verificationType', 'string'], ['pubkey', SolPublicKey]]
});
SCHEMA.set(DecentralizedIdentifier, {
  kind: 'struct',
  fields: [['solData', SolData], ['identifier', 'string']]
});
SCHEMA.set(ServiceEndpoint, {
  kind: 'struct',
  fields: [['id', 'string'], ['endpointType', 'string'], ['endpoint', 'string'], ['description', 'string']]
});
SCHEMA.set(SolPublicKey, {
  kind: 'struct',
  fields: [['bytes', [32]]]
});
SCHEMA.set(ClusterType, {
  kind: 'enum',
  field: 'enum',
  values: [['testnet', Testnet], ['mainnetBeta', MainnetBeta], ['devnet', Devnet], ['development', Development]]
});
SCHEMA.set(Testnet, {
  kind: 'struct',
  fields: []
});
SCHEMA.set(MainnetBeta, {
  kind: 'struct',
  fields: []
});
SCHEMA.set(Devnet, {
  kind: 'struct',
  fields: []
});
SCHEMA.set(Civicnet, {
  kind: 'struct',
  fields: []
});
SCHEMA.set(Development, {
  kind: 'struct',
  fields: []
});

var Initialize = /*#__PURE__*/function (_Assignable) {
  _inheritsLoose(Initialize, _Assignable);

  function Initialize() {
    return _Assignable.apply(this, arguments) || this;
  }

  return Initialize;
}(Assignable);
var Write = /*#__PURE__*/function (_Assignable2) {
  _inheritsLoose(Write, _Assignable2);

  function Write() {
    return _Assignable2.apply(this, arguments) || this;
  }

  return Write;
}(Assignable);
var CloseAccount = /*#__PURE__*/function (_Assignable3) {
  _inheritsLoose(CloseAccount, _Assignable3);

  function CloseAccount() {
    return _Assignable3.apply(this, arguments) || this;
  }

  return CloseAccount;
}(Assignable);
var Resize = /*#__PURE__*/function (_Assignable4) {
  _inheritsLoose(Resize, _Assignable4);

  function Resize() {
    return _Assignable4.apply(this, arguments) || this;
  }

  return Resize;
}(Assignable);
var SolInstruction = /*#__PURE__*/function (_Enum) {
  _inheritsLoose(SolInstruction, _Enum);

  function SolInstruction() {
    return _Enum.apply(this, arguments) || this;
  }

  SolInstruction.initialize = function initialize(size, initData) {
    return new SolInstruction({
      initialize: new Initialize({
        size: size,
        initData: initData
      })
    });
  };

  SolInstruction.write = function write(offset, data) {
    return new SolInstruction({
      write: new Write({
        offset: offset,
        data: data
      })
    });
  };

  SolInstruction.closeAccount = function closeAccount() {
    return new SolInstruction({
      closeAccount: new CloseAccount({})
    });
  };

  SolInstruction.resize = function resize(size, updateData) {
    return new SolInstruction({
      resize: new Resize({
        size: size,
        updateData: updateData
      })
    });
  };

  return SolInstruction;
}(Enum);
function initialize(payer, solKey, authority, size, initData) {
  var keys = [{
    pubkey: payer,
    isSigner: true,
    isWritable: true
  }, {
    pubkey: solKey,
    isSigner: false,
    isWritable: true
  }, {
    pubkey: authority,
    isSigner: false,
    isWritable: false
  }, {
    pubkey: SYSVAR_RENT_PUBKEY,
    isSigner: false,
    isWritable: false
  }, {
    pubkey: SystemProgram.programId,
    isSigner: false,
    isWritable: false
  }];
  var initDataWithAuthorityAndKey = initData.forAuthority(authority);
  var data = SolInstruction.initialize(size, initDataWithAuthorityAndKey).encode();
  return new TransactionInstruction({
    keys: keys,
    programId: PROGRAM_ID,
    data: data
  });
}
function write(solAccount, authority, offset, solData) {
  var keys = [{
    pubkey: solAccount,
    isSigner: false,
    isWritable: true
  }, {
    pubkey: authority,
    isSigner: true,
    isWritable: false
  }];
  var data = SolInstruction.write(offset, solData).encode();
  return new TransactionInstruction({
    keys: keys,
    programId: PROGRAM_ID,
    data: data
  });
}
function closeAccount(solAccount, authority, receiver) {
  var keys = [// the DID account
  {
    pubkey: solAccount,
    isSigner: false,
    isWritable: true
  }, // a key with close permissions on the DID
  {
    pubkey: authority,
    isSigner: true,
    isWritable: false
  }, // the account to receive the lamports
  {
    pubkey: receiver,
    isSigner: false,
    isWritable: false
  }];
  var data = SolInstruction.closeAccount().encode();
  return new TransactionInstruction({
    keys: keys,
    programId: PROGRAM_ID,
    data: data
  });
}
function resize(payer, solKey, authority, size, updateData) {
  var keys = [{
    pubkey: payer,
    isSigner: true,
    isWritable: true
  }, {
    pubkey: solKey,
    isSigner: false,
    isWritable: true
  }, {
    pubkey: authority,
    isSigner: true,
    isWritable: false
  }, {
    pubkey: SYSVAR_RENT_PUBKEY,
    isSigner: false,
    isWritable: false
  }, {
    pubkey: SystemProgram.programId,
    isSigner: false,
    isWritable: false
  }];
  var updateDataWithAuthorityAndKey = updateData.forAuthority(authority);
  var data = SolInstruction.resize(size, updateDataWithAuthorityAndKey).encode();
  return new TransactionInstruction({
    keys: keys,
    programId: PROGRAM_ID,
    data: data
  });
}
SCHEMA.set(SolInstruction, {
  kind: 'enum',
  field: 'enum',
  values: [['initialize', Initialize], ['write', Write], ['closeAccount', CloseAccount], ['resize', Resize]]
});
SCHEMA.set(Initialize, {
  kind: 'struct',
  fields: [['size', 'u64'], ['initData', SolData]]
});
SCHEMA.set(Write, {
  kind: 'struct',
  fields: [['offset', 'u64'], ['data', ['u8']]]
});
SCHEMA.set(CloseAccount, {
  kind: 'struct',
  fields: []
});
SCHEMA.set(Resize, {
  kind: 'struct',
  fields: [['size', 'u64'], ['updateData', SolData]]
});

var SolTransaction = /*#__PURE__*/function () {
  function SolTransaction() {}

  SolTransaction.createDIDInstruction = /*#__PURE__*/function () {
    var _createDIDInstruction = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(payer, authority, size, initData) {
      var solKey;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPDAKeyFromAuthority(authority);

            case 2:
              solKey = _context.sent;
              return _context.abrupt("return", [initialize(payer, solKey, authority, size, initData), solKey]);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function createDIDInstruction(_x, _x2, _x3, _x4) {
      return _createDIDInstruction.apply(this, arguments);
    }

    return createDIDInstruction;
  }();

  SolTransaction.createDID = /*#__PURE__*/function () {
    var _createDID = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(connection, payer, authority, size, initData) {
      var solKey, transaction;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getPDAKeyFromAuthority(authority);

            case 2:
              solKey = _context2.sent;
              // Allocate memory for the account
              transaction = new Transaction().add(initialize(payer.publicKey, solKey, authority, size, initData)); // Send the instructions

              _context2.next = 6;
              return SolanaUtil.sendAndConfirmTransaction(connection, transaction, payer);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function createDID(_x5, _x6, _x7, _x8, _x9) {
      return _createDID.apply(this, arguments);
    }

    return createDID;
  }();

  SolTransaction.getSol = /*#__PURE__*/function () {
    var _getSol = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(connection, clusterType, recordKey) {
      var data;
      return runtime_1.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return connection.getAccountInfo(recordKey);

            case 2:
              data = _context3.sent;

              if (data) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return", null);

            case 5:
              return _context3.abrupt("return", SolData.fromAccount(recordKey, data.data, clusterType));

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function getSol(_x10, _x11, _x12) {
      return _getSol.apply(this, arguments);
    }

    return getSol;
  }();

  SolTransaction.getSolFromAuthority = /*#__PURE__*/function () {
    var _getSolFromAuthority = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(connection, clusterType, authority) {
      var recordKey;
      return runtime_1.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getPDAKeyFromAuthority(authority);

            case 2:
              recordKey = _context4.sent;
              return _context4.abrupt("return", SolTransaction.getSol(connection, clusterType, recordKey));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function getSolFromAuthority(_x13, _x14, _x15) {
      return _getSolFromAuthority.apply(this, arguments);
    }

    return getSolFromAuthority;
  }()
  /**
   * Create and send an instruction to deactivate the DID
   * @param connection A connection to the blockchain
   * @param payer The payer of the transaction - this account also receives the lamports stored
   * @param recordKey
   * @param owner
   */
  ;

  SolTransaction.deactivateSol =
  /*#__PURE__*/
  function () {
    var _deactivateSol = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee5(connection, payer, recordKey, owner) {
      var transaction;
      return runtime_1.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (owner === void 0) {
                owner = payer;
              }

              // Create the transaction to close the Sol DID account
              // The payer must have permissions to deactivate the DID
              // The payer receives the lamports stored in the DID account
              transaction = new Transaction().add(closeAccount(recordKey, owner.publicKey, payer.publicKey)); // Send the instructions

              return _context5.abrupt("return", SolanaUtil.sendAndConfirmTransaction(connection, transaction, payer, owner));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function deactivateSol(_x16, _x17, _x18, _x19) {
      return _deactivateSol.apply(this, arguments);
    }

    return deactivateSol;
  }();

  SolTransaction.resizeAccount = /*#__PURE__*/function () {
    var _resizeAccount = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee6(connection, payer, recordKey, size, updateData, owner) {
      var transaction;
      return runtime_1.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (owner === void 0) {
                owner = payer;
              }

              // Allocate new memory for the account
              transaction = new Transaction().add(resize(payer.publicKey, recordKey, owner.publicKey, size, updateData)); // Send the instructions

              _context6.next = 4;
              return SolanaUtil.sendAndConfirmTransaction(connection, transaction, payer, owner);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function resizeAccount(_x20, _x21, _x22, _x23, _x24, _x25) {
      return _resizeAccount.apply(this, arguments);
    }

    return resizeAccount;
  }();

  SolTransaction.deactivateDIDInstruction = /*#__PURE__*/function () {
    var _deactivateDIDInstruction = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee7(recordKey, authority) {
      return runtime_1.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", closeAccount(recordKey, authority, authority));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function deactivateDIDInstruction(_x26, _x27) {
      return _deactivateDIDInstruction.apply(this, arguments);
    }

    return deactivateDIDInstruction;
  }();

  SolTransaction.updateDIDInstruction = /*#__PURE__*/function () {
    var _updateDIDInstruction = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee8(connection, clusterType, recordKey, authority, dataToMerge, mergeBehaviour) {
      var existingData, mergedData;
      return runtime_1.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.getSol(connection, clusterType, recordKey);

            case 2:
              existingData = _context8.sent;

              if (existingData) {
                _context8.next = 5;
                break;
              }

              throw new Error('DID does not exist');

            case 5:
              mergedData = existingData.merge(dataToMerge, mergeBehaviour === 'Overwrite');
              return _context8.abrupt("return", write(recordKey, authority, 0, mergedData.encode()));

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function updateDIDInstruction(_x28, _x29, _x30, _x31, _x32, _x33) {
      return _updateDIDInstruction.apply(this, arguments);
    }

    return updateDIDInstruction;
  }();

  SolTransaction.updateDID = /*#__PURE__*/function () {
    var _updateDID = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee9(connection, clusterType, payer, recordKey, dataToMerge, mergeBehaviour, owner) {
      var instruction, transaction;
      return runtime_1.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (owner === void 0) {
                owner = payer;
              }

              _context9.next = 3;
              return this.updateDIDInstruction(connection, clusterType, recordKey, owner.publicKey, dataToMerge, mergeBehaviour);

            case 3:
              instruction = _context9.sent;
              transaction = new Transaction().add(instruction); // Send the instructions

              return _context9.abrupt("return", SolanaUtil.sendAndConfirmTransaction(connection, transaction, payer, owner));

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function updateDID(_x34, _x35, _x36, _x37, _x38, _x39, _x40) {
      return _updateDID.apply(this, arguments);
    }

    return updateDID;
  }();

  return SolTransaction;
}();

/**
 * Registers a SOL DID on Solana.
 * @param request
 */

var register = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var payer, owner, cluster, size, connection;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payer = makeKeypair(request.payer);
            owner = request.owner ? new PublicKey(request.owner) : getPublicKey(request.payer);
            cluster = request.cluster || ClusterType.mainnetBeta();
            size = request.size || DEFAULT_DOCUMENT_SIZE;
            connection = request.connection || new Connection(cluster.solanaUrl(), SOLANA_COMMITMENT);
            _context.t0 = SolTransaction;
            _context.t1 = connection;
            _context.t2 = payer;
            _context.t3 = owner;
            _context.t4 = size;

            if (!request.document) {
              _context.next = 16;
              break;
            }

            _context.next = 13;
            return SolData.parse(request.document);

          case 13:
            _context.t5 = _context.sent;
            _context.next = 23;
            break;

          case 16:
            _context.t6 = SolData;
            _context.next = 19;
            return getPDAKeyFromAuthority(owner);

          case 19:
            _context.t7 = _context.sent;
            _context.t8 = owner;
            _context.t9 = cluster;
            _context.t5 = _context.t6.sparse.call(_context.t6, _context.t7, _context.t8, _context.t9);

          case 23:
            _context.t10 = _context.t5;
            _context.next = 26;
            return _context.t0.createDID.call(_context.t0, _context.t1, _context.t2, _context.t3, _context.t4, _context.t10);

          case 26:
            return _context.abrupt("return", DecentralizedIdentifier.create(owner, cluster).toString());

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function register(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createRegisterInstruction = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(_ref2) {
    var payer, authority, _ref2$size, size, document, initData;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payer = _ref2.payer, authority = _ref2.authority, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? DEFAULT_DOCUMENT_SIZE : _ref2$size, document = _ref2.document;

            if (!document) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return SolData.parse(document);

          case 4:
            _context2.t0 = _context2.sent;
            _context2.next = 14;
            break;

          case 7:
            _context2.t1 = SolData;
            _context2.next = 10;
            return getPDAKeyFromAuthority(authority);

          case 10:
            _context2.t2 = _context2.sent;
            _context2.t3 = authority;
            _context2.t4 = ClusterType.mainnetBeta();
            _context2.t0 = _context2.t1.sparse.call(_context2.t1, _context2.t2, _context2.t3, _context2.t4);

          case 14:
            initData = _context2.t0;
            return _context2.abrupt("return", SolTransaction.createDIDInstruction(payer, authority, size, initData));

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createRegisterInstruction(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Updates a SOL DID on Solana.
 * @param request
 */

var update = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var id, payer, owner, cluster, connection;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = DecentralizedIdentifier.parse(request.did);
            payer = makeKeypair(request.payer);
            owner = request.owner ? makeKeypair(request.owner) : undefined;
            cluster = id.clusterType;
            connection = request.connection || new Connection(cluster.solanaUrl(), 'recent');
            _context.t0 = SolTransaction;
            _context.t1 = connection;
            _context.t2 = cluster;
            _context.t3 = payer;
            _context.next = 11;
            return id.pdaSolanaPubkey();

          case 11:
            _context.t4 = _context.sent;
            _context.next = 14;
            return SolData.parse(request.document);

          case 14:
            _context.t5 = _context.sent;
            _context.t6 = request.mergeBehaviour || 'Append';
            _context.t7 = owner;
            _context.next = 19;
            return _context.t0.updateDID.call(_context.t0, _context.t1, _context.t2, _context.t3, _context.t4, _context.t5, _context.t6, _context.t7);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function update(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createUpdateInstruction = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(_ref2) {
    var did, authority, document, mergeBehaviour, connectionInput, id, cluster, connection;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            did = _ref2.did, authority = _ref2.authority, document = _ref2.document, mergeBehaviour = _ref2.mergeBehaviour, connectionInput = _ref2.connection;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            _context2.t0 = SolTransaction;
            _context2.t1 = connection;
            _context2.t2 = cluster;
            _context2.next = 9;
            return id.pdaSolanaPubkey();

          case 9:
            _context2.t3 = _context2.sent;
            _context2.t4 = authority;
            _context2.next = 13;
            return SolData.parse(document);

          case 13:
            _context2.t5 = _context2.sent;
            _context2.t6 = mergeBehaviour || 'Append';
            return _context2.abrupt("return", _context2.t0.updateDIDInstruction.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3, _context2.t4, _context2.t5, _context2.t6));

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createUpdateInstruction(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var makeVerificationMethod = function makeVerificationMethod(did, key, alias) {
  return {
    id: did + "#" + alias,
    publicKeyBase58: key,
    type: 'Ed25519VerificationKey2018',
    controller: did
  };
};

var isDIDComponent = function isDIDComponent(component) {
  return has('id', component);
};

var hasAlias = function hasAlias(alias) {
  return function (component) {
    return isDIDComponent(component) ? component.id.endsWith("#" + alias) // DIDComponent case ID must match #alias
    : component.endsWith("#" + alias);
  };
}; // string case - must match #alias

var isDefault = /*#__PURE__*/hasAlias('default');
var findVerificationMethodWithAlias = function findVerificationMethodWithAlias(document, alias) {
  var _document$verificatio;

  return (_document$verificatio = document.verificationMethod) == null ? void 0 : _document$verificatio.find(hasAlias(alias));
}; // filter the default key from capability invocation and verification method
// If it is the only one in the capabilityInvocation array, it is inferred by default by the program,
// and therefore does not need to be stored on chain.
// It never needs to be stored on chain in the verificationMethod array, as it is always inferred

var sanitizeDefaultKeys = function sanitizeDefaultKeys(document) {
  var _document$capabilityI;

  // if verificationMethod contains the default key, remove it (it is always added by default)
  if (document.verificationMethod && findVerificationMethodWithAlias(document, 'default')) {
    document.verificationMethod = filter(function (x) {
      return !isDefault(x);
    }, document.verificationMethod); // if this now means the verification method array is empty, remove the array

    if (document.verificationMethod.length === 0) {
      delete document.verificationMethod;
    }
  }

  if (((_document$capabilityI = document.capabilityInvocation) == null ? void 0 : _document$capabilityI.length) === 1 && isDefault(document.capabilityInvocation[0])) {
    delete document.capabilityInvocation;
  }
};
var filterNotNil = function filterNotNil(entries) {
  return entries.filter(complement(isNil));
};
var didToPublicKey = function didToPublicKey(did) {
  return DecentralizedIdentifier.parse(did).authorityPubkey.toPublicKey();
};

var privateKeyIsArray = function privateKeyIsArray(privateKey) {
  return Array.isArray(privateKey);
};
var privateKeyIsString = function privateKeyIsString(privateKey) {
  return typeof privateKey === 'string';
};
var privateKeyIsBuffer = function privateKeyIsBuffer(privateKey) {
  return Buffer.isBuffer(privateKey);
};
var privateKeyIsUint8Array = function privateKeyIsUint8Array(privateKey) {
  return privateKey instanceof Uint8Array;
};
/**
 * Create a Solana account object from an x25519 private key
 * @param privateKey
 */

var makeKeypair = function makeKeypair(privateKey) {
  if (privateKeyIsArray(privateKey)) {
    return Keypair.fromSecretKey(Buffer.from(privateKey));
  }

  if (privateKeyIsBuffer(privateKey) || privateKeyIsUint8Array(privateKey)) return Keypair.fromSecretKey(privateKey);

  if (privateKeyIsString(privateKey)) {
    var privateKeyHex = decode(privateKey);
    return Keypair.fromSecretKey(privateKeyHex);
  }

  throw new Error('Incompatible private key format');
};
/**
 * Given a private key on the x25519 curve, get its public key
 * @param privateKey
 */

var getPublicKey = function getPublicKey(privateKey) {
  return makeKeypair(privateKey).publicKey;
};
var generateKeypair = function generateKeypair() {
  var account = Keypair.generate();
  return {
    secretKey: encode(account.secretKey),
    publicKey: account.publicKey.toBase58()
  };
};
var keyToIdentifier = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(key, clusterType) {
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (clusterType === void 0) {
              clusterType = /*#__PURE__*/ClusterType.mainnetBeta();
            }

            return _context2.abrupt("return", DecentralizedIdentifier.create(key, clusterType).toString());

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function keyToIdentifier(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var didIsRegistered = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(connection, did) {
    var decentralizedIdentifier, pda, account;
    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            decentralizedIdentifier = DecentralizedIdentifier.parse(did);
            _context3.next = 3;
            return decentralizedIdentifier.pdaSolanaPubkey();

          case 3:
            pda = _context3.sent;
            _context3.next = 6;
            return connection.getAccountInfo(pda);

          case 6:
            account = _context3.sent;

            if (account) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return", false);

          case 9:
            if (!account.owner.equals(PROGRAM_ID)) {
              _context3.next = 11;
              break;
            }

            return _context3.abrupt("return", true);

          case 11:
            throw new Error("Invalid DID " + did + ", the derived account " + pda + " is registered to another program");

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function didIsRegistered(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Creates and sends a transaction with the provided instructions
 */

var sendTransaction = function sendTransaction(connection, instructions, payer, owner) {
  var _Transaction;

  var transaction = (_Transaction = new Transaction()).add.apply(_Transaction, instructions);

  var keys = [payer]; // Checks to see if the owner key needs to be included

  instructions.forEach(function (instruction) {
    instruction.keys.map(function (meta) {
      if (meta.isSigner && meta.pubkey.equals(owner.publicKey)) {
        keys.push(owner);
      }
    });
  }); // Send the instructions

  return SolanaUtil.sendAndConfirmTransaction.apply(SolanaUtil, [connection, transaction].concat(keys));
};
/**
 * Creates an instruction that updates a DID Document.
 *
 * This will return a register instruction (if the DID is not yet registered on chain)
 * or an update instruction (if it is already registered), but not both
 */

var createRegisterOrUpdateInstruction = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(did, payer, authority, document, connection, mergeBehaviour, size) {
    var isRegistered, register;
    return runtime_1.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (size === void 0) {
              size = DEFAULT_DOCUMENT_SIZE;
            }

            _context4.next = 3;
            return didIsRegistered(connection, did);

          case 3:
            isRegistered = _context4.sent;

            if (isRegistered) {
              _context4.next = 11;
              break;
            }

            if (authority.equals(didToPublicKey(did))) {
              _context4.next = 7;
              break;
            }

            throw new Error('Authority must be did for creation');

          case 7:
            _context4.next = 9;
            return createRegisterInstruction({
              payer: payer,
              authority: authority,
              document: document,
              size: size
            });

          case 9:
            register = _context4.sent;
            return _context4.abrupt("return", register[0]);

          case 11:
            return _context4.abrupt("return", createUpdateInstruction({
              authority: authority,
              document: document,
              did: did,
              connection: connection,
              mergeBehaviour: mergeBehaviour
            }));

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function createRegisterOrUpdateInstruction(_x7, _x8, _x9, _x10, _x11, _x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Resize a SOL DID Account on Solana.
 * @param request
 */

var resize$1 = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var id, payer, owner, cluster, size, connection;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = DecentralizedIdentifier.parse(request.did);
            payer = makeKeypair(request.payer);
            owner = request.owner ? makeKeypair(request.owner) : undefined;
            cluster = request.cluster || ClusterType.mainnetBeta();
            size = request.size || DEFAULT_DOCUMENT_SIZE;
            connection = request.connection || new Connection(cluster.solanaUrl(), SOLANA_COMMITMENT);
            _context.t0 = SolTransaction;
            _context.t1 = connection;
            _context.t2 = payer;
            _context.next = 11;
            return id.pdaSolanaPubkey();

          case 11:
            _context.t3 = _context.sent;
            _context.t4 = size;
            _context.next = 15;
            return SolData.parse(request.document);

          case 15:
            _context.t5 = _context.sent;
            _context.t6 = owner;
            _context.next = 19;
            return _context.t0.resizeAccount.call(_context.t0, _context.t1, _context.t2, _context.t3, _context.t4, _context.t5, _context.t6);

          case 19:
            return _context.abrupt("return", id.toString());

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resize(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Resolves a SOL DID to a document,
 * @param identifier The DID e.g. did:sol:ygGfLvAyuRymPNv2fJDK1ZMpdy59m8cV5dak6A8uHKa
 * or did:sol:devnet:6Na3uiqyRGZZQdd19RLCb6kJHR51reFdhXzAuc6Y8Yef
 * @throws Error if the document is not found
 */

var resolve = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(identifier, options) {
    var id, connection, solData;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (options === void 0) {
              options = {};
            }

            id = DecentralizedIdentifier.parse(identifier);
            connection = options.connection || new Connection(id.clusterType.solanaUrl(), SOLANA_COMMITMENT);
            _context.t0 = SolTransaction;
            _context.t1 = connection;
            _context.t2 = id.clusterType;
            _context.next = 8;
            return id.pdaSolanaPubkey();

          case 8:
            _context.t3 = _context.sent;
            _context.next = 11;
            return _context.t0.getSol.call(_context.t0, _context.t1, _context.t2, _context.t3);

          case 11:
            solData = _context.sent;

            if (!(solData !== null)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", solData.toDIDDocument());

          case 16:
            _context.t4 = SolData;
            _context.next = 19;
            return id.pdaSolanaPubkey();

          case 19:
            _context.t5 = _context.sent;
            _context.t6 = id.authorityPubkey.toPublicKey();
            _context.t7 = id.clusterType;
            return _context.abrupt("return", _context.t4.sparse.call(_context.t4, _context.t5, _context.t6, _context.t7).toDIDDocument());

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resolve(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Deactivates a SOL DID on Solana.
 * @param request
 */

var deactivate = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var id, payer, owner, cluster, connection;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = DecentralizedIdentifier.parse(request.did);
            payer = makeKeypair(request.payer);
            owner = request.owner ? makeKeypair(request.owner) : undefined;
            cluster = id.clusterType;
            connection = request.connection || new Connection(cluster.solanaUrl(), SOLANA_COMMITMENT);
            _context.t0 = SolTransaction;
            _context.t1 = connection;
            _context.t2 = payer;
            _context.next = 10;
            return id.pdaPubkey().then(function (key) {
              return key.toPublicKey();
            });

          case 10:
            _context.t3 = _context.sent;
            _context.t4 = owner;
            _context.next = 14;
            return _context.t0.deactivateSol.call(_context.t0, _context.t1, _context.t2, _context.t3, _context.t4);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function deactivate(_x) {
    return _ref.apply(this, arguments);
  };
}();

var updatedCapabilityInvocation = function updatedCapabilityInvocation(existingDocument, newVerificationMethod) {
  if (!existingDocument || !existingDocument.capabilityInvocation) {
    return [newVerificationMethod.id];
  }

  if (existingDocument.capabilityInvocation.length === 1) {
    if (isDefault(existingDocument.capabilityInvocation[0])) {
      // this is added by default when capabilityInvocation is empty on chain
      // when adding a new one, include it to avoid overwriting
      return [].concat(existingDocument.capabilityInvocation, [newVerificationMethod.id]);
    }
  } // no need to add existing capabilityInvocations as we are using merge behaviour "append"


  return [newVerificationMethod.id];
};
/**
 * Adds a key to the DID
 *
 * It will send a register instruction (if the DID is not yet registered on chain)
 * or an update instruction (if it is already registered)
 */

var addKey = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var did, connectionInput, key, fragment, id, cluster, connection, payer, owner, instruction;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            did = request.did, connectionInput = request.connection, key = request.key, fragment = request.fragment;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            payer = makeKeypair(request.payer);
            owner = makeKeypair(request.owner || request.payer);
            _context.next = 8;
            return createAddKeyInstruction({
              payer: payer.publicKey,
              authority: owner.publicKey,
              key: new PublicKey(key),
              fragment: fragment,
              connection: connection,
              did: did
            });

          case 8:
            instruction = _context.sent;
            _context.next = 11;
            return sendTransaction(connection, [instruction], payer, owner);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addKey(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createAddKeyInstruction = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(request) {
    var payer, authority, did, connectionInput, key, fragment, size, id, cluster, connection, existingDocument, verificationMethod, document;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payer = request.payer, authority = request.authority, did = request.did, connectionInput = request.connection, key = request.key, fragment = request.fragment, size = request.size;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            _context2.next = 6;
            return resolve(did, {
              connection: connection
            });

          case 6:
            existingDocument = _context2.sent;
            verificationMethod = makeVerificationMethod(did, key.toBase58(), fragment);
            document = {
              verificationMethod: [verificationMethod],
              capabilityInvocation: updatedCapabilityInvocation(existingDocument, verificationMethod)
            };
            return _context2.abrupt("return", createRegisterOrUpdateInstruction(did, payer, authority, document, connection, 'Append', size));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createAddKeyInstruction(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Removes a key from the DID
 */

var removeKey = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var did, connectionInput, fragment, id, cluster, connection, payer, owner, instruction;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            did = request.did, connectionInput = request.connection, fragment = request.fragment;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            payer = makeKeypair(request.payer);
            owner = makeKeypair(request.owner || request.payer);
            _context.next = 8;
            return createRemoveKeyInstruction({
              payer: payer.publicKey,
              authority: owner.publicKey,
              connection: connection,
              did: did,
              fragment: fragment
            });

          case 8:
            instruction = _context.sent;
            _context.next = 11;
            return sendTransaction(connection, [instruction], payer, owner);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function removeKey(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createRemoveKeyInstruction = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(request) {
    var _document$verificatio, _document$capabilityI;

    var payer, authority, did, connectionInput, size, fragment, id, cluster, connection, existingDocument, verificationMethodToRemove, document;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payer = request.payer, authority = request.authority, did = request.did, connectionInput = request.connection, size = request.size, fragment = request.fragment;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            _context2.next = 6;
            return resolve(did, {
              connection: connection
            });

          case 6:
            existingDocument = _context2.sent;
            verificationMethodToRemove = findVerificationMethodWithAlias(existingDocument, fragment);

            if (verificationMethodToRemove) {
              _context2.next = 10;
              break;
            }

            throw new Error("Key " + fragment + " not found on " + did);

          case 10:
            // to save space on-chain, do not register properties that were unchanged or not registered in the existing doc
            document = _extends({}, pick(['controller', 'service'], existingDocument), {
              assertionMethod: existingDocument.assertionMethod && without([verificationMethodToRemove.id], existingDocument.assertionMethod),
              authentication: existingDocument.authentication && without([verificationMethodToRemove.id], existingDocument.authentication),
              capabilityInvocation: existingDocument.capabilityInvocation && without([verificationMethodToRemove.id], existingDocument.capabilityInvocation),
              capabilityDelegation: existingDocument.capabilityDelegation && without([verificationMethodToRemove.id], existingDocument.capabilityDelegation),
              keyAgreement: existingDocument.keyAgreement && without([verificationMethodToRemove.id], existingDocument.keyAgreement),
              verificationMethod: existingDocument.verificationMethod && without([verificationMethodToRemove], existingDocument.verificationMethod)
            }); // filter default keys from capability invocation and verification method
            // if they are the only ones, as they are added by the client by default, and do not need
            // to be stored on chain

            if (((_document$verificatio = document.verificationMethod) == null ? void 0 : _document$verificatio.length) === 1 && isDefault(document.verificationMethod[0])) {
              delete document.verificationMethod;
            }

            if (((_document$capabilityI = document.capabilityInvocation) == null ? void 0 : _document$capabilityI.length) === 1 && isDefault(document.capabilityInvocation[0])) {
              delete document.capabilityInvocation;
            }

            sanitizeDefaultKeys(document);
            return _context2.abrupt("return", createRegisterOrUpdateInstruction(did, payer, authority, document, connection, 'Overwrite', size));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createRemoveKeyInstruction(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Adds a controller to the DID
 *
 * It will send a register instruction (if the DID is not yet registered on chain)
 * or an update instruction (if it is already registered)
 */

var addController = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var did, connectionInput, controller, id, cluster, connection, payer, owner, instruction;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            did = request.did, connectionInput = request.connection, controller = request.controller;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            payer = makeKeypair(request.payer);
            owner = makeKeypair(request.owner || request.payer);
            _context.next = 8;
            return createAddControllerInstruction({
              payer: payer.publicKey,
              authority: owner.publicKey,
              connection: connection,
              did: did,
              controller: controller
            });

          case 8:
            instruction = _context.sent;
            _context.next = 11;
            return sendTransaction(connection, [instruction], payer, owner);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addController(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createAddControllerInstruction = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(request) {
    var payer, authority, did, connectionInput, size, controller, id, cluster, connection, document;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payer = request.payer, authority = request.authority, did = request.did, connectionInput = request.connection, size = request.size, controller = request.controller;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            document = {
              controller: [controller]
            };
            return _context2.abrupt("return", createRegisterOrUpdateInstruction(did, payer, authority, document, connection, 'Append', size));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createAddControllerInstruction(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var hasController = function hasController(document, controller) {
  if (!document.controller) return false;

  if (Array.isArray(document.controller)) {
    return document.controller.includes(controller);
  }

  return document.controller === controller;
};
/**
 * Removes controller to the DID
 */


var removeController = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var did, connectionInput, controller, id, cluster, connection, payer, owner, instruction;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            did = request.did, connectionInput = request.connection, controller = request.controller;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            payer = makeKeypair(request.payer);
            owner = makeKeypair(request.owner || request.payer);
            _context.next = 8;
            return createRemoveControllerInstruction({
              payer: payer.publicKey,
              authority: owner.publicKey,
              connection: connection,
              did: did,
              controller: controller
            });

          case 8:
            instruction = _context.sent;
            _context.next = 11;
            return sendTransaction(connection, [instruction], payer, owner);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function removeController(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createRemoveControllerInstruction = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(request) {
    var payer, authority, did, connectionInput, size, controller, id, cluster, connection, existingDocument, newControllers, document;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payer = request.payer, authority = request.authority, did = request.did, connectionInput = request.connection, size = request.size, controller = request.controller;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            _context2.next = 6;
            return resolve(did, {
              connection: connection
            });

          case 6:
            existingDocument = _context2.sent;

            if (hasController(existingDocument, controller)) {
              _context2.next = 9;
              break;
            }

            throw new Error("Controller " + controller + " not found on " + did);

          case 9:
            // remove the controller from the list
            newControllers = without([controller], filterNotNil(flatten([existingDocument.controller])));
            document = _extends({}, pick(['verificationMethod', 'authentication', 'assertionMethod', 'keyAgreement', 'capabilityInvocation', 'capabilityDelegation', 'service'], existingDocument), {
              // remove the controller property if empty. note this works only with mergeBehaviour "Overwrite"
              controller: newControllers.length ? newControllers : undefined
            });
            sanitizeDefaultKeys(document);
            return _context2.abrupt("return", createRegisterOrUpdateInstruction(did, payer, authority, document, connection, 'Overwrite', size));

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createRemoveControllerInstruction(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Adds a service to the DID
 *
 * It will send a register instruction (if the DID is not yet registered on chain)
 * or an update instruction (if it is already registered)
 */

var addService = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var did, connectionInput, service, id, cluster, connection, payer, owner, instruction;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            did = request.did, connectionInput = request.connection, service = request.service;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            payer = makeKeypair(request.payer);
            owner = makeKeypair(request.owner || request.payer);
            _context.next = 8;
            return createAddServiceInstruction({
              payer: payer.publicKey,
              authority: owner.publicKey,
              connection: connection,
              did: did,
              service: service
            });

          case 8:
            instruction = _context.sent;
            _context.next = 11;
            return sendTransaction(connection, [instruction], payer, owner);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addService(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createAddServiceInstruction = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(request) {
    var payer, authority, did, connectionInput, size, service, id, cluster, connection, document;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payer = request.payer, authority = request.authority, did = request.did, connectionInput = request.connection, size = request.size, service = request.service;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            document = {
              service: [service]
            };
            return _context2.abrupt("return", createRegisterOrUpdateInstruction(did, payer, authority, document, connection, 'Append', size));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createAddServiceInstruction(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var findServiceWithFragment = function findServiceWithFragment(document, fragment) {
  var _document$service;

  return (_document$service = document.service) == null ? void 0 : _document$service.find(hasAlias(fragment));
};
/**
 * Removes a service from a DID
 */


var removeService = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(request) {
    var did, connectionInput, fragment, id, cluster, connection, payer, owner, instruction;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            did = request.did, connectionInput = request.connection, fragment = request.fragment;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            payer = makeKeypair(request.payer);
            owner = makeKeypair(request.owner || request.payer);
            _context.next = 8;
            return createRemoveServiceInstruction({
              payer: payer.publicKey,
              authority: owner.publicKey,
              connection: connection,
              did: did,
              fragment: fragment
            });

          case 8:
            instruction = _context.sent;
            _context.next = 11;
            return sendTransaction(connection, [instruction], payer, owner);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function removeService(_x) {
    return _ref.apply(this, arguments);
  };
}();
var createRemoveServiceInstruction = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(request) {
    var payer, authority, did, connectionInput, size, fragment, id, cluster, connection, existingDocument, serviceToRemove, newServices, document;
    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payer = request.payer, authority = request.authority, did = request.did, connectionInput = request.connection, size = request.size, fragment = request.fragment;
            id = DecentralizedIdentifier.parse(did);
            cluster = id.clusterType;
            connection = connectionInput || new Connection(cluster.solanaUrl(), 'recent');
            _context2.next = 6;
            return resolve(did, {
              connection: connection
            });

          case 6:
            existingDocument = _context2.sent;
            serviceToRemove = findServiceWithFragment(existingDocument, fragment);

            if (serviceToRemove) {
              _context2.next = 10;
              break;
            }

            throw new Error("Service " + fragment + " not found on " + did);

          case 10:
            // get the new list of services without the one being removed.
            // the cast is safe here as if the service array did not exist, it would fail above
            newServices = without([serviceToRemove], existingDocument.service);
            document = _extends({}, pick(['verificationMethod', 'authentication', 'assertionMethod', 'keyAgreement', 'capabilityInvocation', 'capabilityDelegation', 'controller'], existingDocument), {
              // remove the service property if empty. note this works only with mergeBehaviour "Overwrite"
              service: newServices.length ? newServices : undefined
            });
            sanitizeDefaultKeys(document);
            return _context2.abrupt("return", createRegisterOrUpdateInstruction(did, payer, authority, document, connection, 'Overwrite', size));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createRemoveServiceInstruction(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

export { Civicnet, CloseAccount, ClusterType, DEFAULT_KEY_ID, DecentralizedIdentifier, Development, Devnet, Initialize, MainnetBeta, Resize, ServiceEndpoint, SolData, SolInstruction, SolPublicKey, SolTransaction, SolanaUtil, Testnet, VERSION, VerificationMethod, Write, addController, addKey, addService, closeAccount, createAddControllerInstruction, createAddKeyInstruction, createAddServiceInstruction, createRegisterInstruction, createRegisterOrUpdateInstruction, createRemoveControllerInstruction, createRemoveKeyInstruction, createRemoveServiceInstruction, createUpdateInstruction, deactivate, generateKeypair, getPDAKeyFromAuthority, initialize, keyToIdentifier, register, removeController, removeKey, removeService, resize$1 as resize, resolve, update, write };
//# sourceMappingURL=sol-did-client-legacy.esm.js.map
